export default function($form) {
  var $params=$form.getExtForm();
  if (!$form.isValid(true)) {
    return;
  }

  $params.btnDebounce(function() {
    var p ={
      taskId:$params.taskId,
      appId:$params.appId,
      formId:$params.formId
    }
    if($params.comment){
      p['$comment']=$params.comment;
    }
    var btnName = $params.action;
    $params.setBtnLoading(true, btnName);
    PF.confirm('您确定送给领导？', '提示', {type: 'info'}).then(() => {
      //p.checkGoOut = true; //检查领导是否外出
      p.actionDescription = '送领导';
      p.leaderActivityName='';
      if($params.taskData.taskActivityType=='notify'){
        if($params.activity.circularLeaderActivityName){
          p.leaderActivityName = $params.activity.circularLeaderActivityName;
        }
      }else{
        if($params.activity.leaderActivityName){
          p.leaderActivityName = $params.activity.leaderActivityName;
        }
      }
      if($params.extParams && $params.extParams.fullAuthType){
        p.fullAuthType = $params.extParams.fullAuthType;
      }
      PF.api.process.delegateSendLeader(p).then(res => {
        if (res.success) {
          $params.formActionComplete(); //关闭窗口
        }
        $params.setBtnLoading(false, btnName);
      }).catch(() => {
        $params.setBtnLoading(false, btnName);
      });
    }).catch(() => {
      $params.setBtnLoading(false, btnName);
    });
  });
}



// WEBPACK FOOTER //
// ./src/common/components/extend/form/src/config/flow-sendleader.js